import { ColorModeProvider, useTheme } from '@airbus/components-react/components'
import React, { createContext, useState } from 'react'

type LightDark = 'light' | 'dark'

export type LightDarkModeContext = {
  mode: LightDark
  setMode: React.Dispatch<React.SetStateAction<LightDark>>
  getBackgroundColor: (b?: boolean) => string
}

const LightDarkContext = createContext<LightDarkModeContext>({
  mode: 'light',
  setMode: () => {},
  getBackgroundColor: () => '',
})

export const LightDarkProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setMode] = useState<LightDark>('light')
  const theme = useTheme()

  const getBackgroundColor = (isPageEmpty = false) => {
    let backgroundColor = 'white'

    if (isPageEmpty) backgroundColor = 'rgb(0, 32, 96)'
    else if (mode === 'dark') backgroundColor = theme.color.brand.darkest

    return backgroundColor
  }

  return (
    <ColorModeProvider mode={mode}>
      <LightDarkContext.Provider value={{ mode, setMode, getBackgroundColor }}>{children}</LightDarkContext.Provider>
    </ColorModeProvider>
  )
}

export default LightDarkContext
